import React, { Component } from "react";

class WPRReportRow extends Component {
   render() {
      const props = this.props;
      return (
         <tr key={props.keys}>
            <td>{props.value["job-card-no"]}</td>
            <td>{props.value["service-req-no"]}</td>
            <td>{props.value["part-no"]}</td>
            <td>{props.value["part-name"]}</td>
            <td>{props.value["qty"]} {props.value["qty-unit"]}</td>
         </tr>
      );
   }
}

export default WPRReportRow;
